export default (trials, locations) => {
  const allTrialIds = trials.map(trial => trial._id);
  return locations?.filter(location => {
    const { trial_ids = [] } = location;
    return trial_ids.some(trialId => allTrialIds.includes(trialId));
  });
};
